import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { useHttp } from './http'

export function useWebsites() {
    const $axios = useHttp();
    let website = ref({})
    const websites = ref([])

    const errors = ref('')
    const isRequesting = ref(false)
    const router = useRouter()

    const getWebsites = async () => {
        isRequesting.value = true;
        try {
            const { data: { data: websitesData } } = await $axios.get("/websites");
            websites.value = websitesData;
        } catch (error) {
            console.error(error);
        } finally {
            isRequesting.value = false;
        }
    }

    const getWebsite = async (id) => {
        try {
            const { data: { data: websiteData } } = await $axios.get(`/websites/${id}`)
            website.value = websiteData;
        } catch (error) {
            console.error(error);
        }
    }

    const getEmailAliases = async (websiteId, ownDomainId) => {
        try {
            const { data: { data: aliases } } = await $axios.get(
                `/websites/${websiteId}/own-domains/${ownDomainId}/email-aliases`
            );
            const domain = website.value.ownDomains?.find(d => d.id === ownDomainId);
            if (domain) {
                domain.emailAliases = aliases;
            }
        } catch (error) {
            console.error(error);
        }
    }

    const storeWebsite = async (data) => {
        errors.value = '';
        try {
            return await $axios.post('/websites', data)
                .then(({ data }) => { console.log(data); return data.data })
        } catch (e) {
            if (e.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
        }
    }

    const deleteWebsiteOwnDomain = async (websiteId, domainId) => {
        errors.value = ''
        try {
            await $axios.delete(`/websites/${websiteId}/own-domains/${domainId}`, {
                headers: {
                    'Request-Origin-Timestamp': Date.now(),
                    'Request-Origin-Entity': `own-domain-${domainId}-delete`
                }
            })
        } catch (e) {
            console.log(e);
            if (e.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
        }
    }

    const updateWebsiteDomains = async (websiteId, data) => {
        errors.value = ''
        try {
            await $axios.post(`/websites/${websiteId}/own-domains`, data, {
                headers: {
                    'Request-Origin-Timestamp': Date.now(),
                    'Request-Origin-Entity': `websites-${websiteId}-domains`
                }
            })
        } catch (e) {
            if (e.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
        }
    }

    const updateWebsite = async (id) => {
        errors.value = '';
        console.log(website.value.properties, 'properties')
        try {
            await $axios.patch(`/websites/${id}`, { properties: website.value.properties },
                {
                    headers: {
                        'Request-Origin-Timestamp': Date.now(),
                        'Request-Origin-Entity': `websites-${id}-update`
                    }
                }
            )
            // await router.push({ name: 'website.get' })
        } catch (e) {
            console.log(e);
            if (e?.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
            else {
                console.log(e);
            }
        }
    }

    const destroyWebsite = async (id) => {
        await $axios.delete(`/websites/${id}`)
    }

    const addEmailAlias = async (websiteId, ownDomainId, data) => {
        errors.value = ''
        try {
            await $axios.post(`/websites/${websiteId}/own-domains/${ownDomainId}/email-aliases`, data, {
                headers: {
                    'Request-Origin-Timestamp': Date.now(),
                    'Request-Origin-Entity': `websites-${websiteId}-domains`
                }
            })
        } catch (e) {
            console.error(e);
            if (e.response.status === 422) {
                for (const key in e.response.data.errors) {
                    errors.value += e.response.data.errors[key][0] + ' ';
                }
            }
        }        
    }

    const deleteEmailAlias = async (websiteId, ownDomainId, id) => {
        await $axios.delete(`/websites/${websiteId}/own-domains/${ownDomainId}/email-aliases/${id}`)
    }

    return {
        isRequesting,
        errors,
        website,
        websites,
        getWebsite,
        getWebsites,
        getEmailAliases,
        storeWebsite,
        updateWebsite,
        destroyWebsite,
        updateWebsiteDomains,
        deleteWebsiteOwnDomain,
        addEmailAlias,
        deleteEmailAlias,
    }
}
